// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_conversationEvents(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "NewConversationEvent",
    "NewConversationReplyEvent"
  ]);
}

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let responseConverter = {"__root":{"conversationEvents_NewConversationReplyEvent_message":{"f":""},"conversationEvents_NewConversationEvent_conversation":{"f":""},"conversationEvents":{"u":"response_conversationEvents"}}};

let responseConverterMap = {
  response_conversationEvents: unwrap_response_conversationEvents
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sentAt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "ConversationMessageFileConnection",
  "kind": "LinkedField",
  "name": "files",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "ConversationMessageImageConnection",
  "kind": "LinkedField",
  "name": "images",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v10 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "from",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v3/*: any*/)
      ],
      "type": "Agent",
      "abstractKey": null
    },
    (v10/*: any*/)
  ],
  "storageKey": null
},
v12 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v14 = {
  "kind": "Variable",
  "name": "ratio",
  "variableName": "__relay_internal__pv__DevicePixelRatio"
},
v15 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "format",
        "value": "SHORT"
      }
    ],
    "kind": "ScalarField",
    "name": "formatted",
    "storageKey": "formatted(format:\"SHORT\")"
  }
],
v16 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "headline",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PriceRange",
    "kind": "LinkedField",
    "name": "priceRange",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Price",
        "kind": "LinkedField",
        "name": "maxPrice",
        "plural": false,
        "selections": (v15/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Price",
        "kind": "LinkedField",
        "name": "minPrice",
        "plural": false,
        "selections": (v15/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "PropertyImageConnection",
  "kind": "LinkedField",
  "name": "images",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PropertyImageEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageAttachment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "crop",
                  "value": true
                },
                {
                  "kind": "Literal",
                  "name": "embed",
                  "value": true
                },
                {
                  "kind": "Literal",
                  "name": "height",
                  "value": 324
                },
                (v14/*: any*/),
                {
                  "kind": "Literal",
                  "name": "width",
                  "value": 324
                }
              ],
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            (v9/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationDisplay",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "propertyLocation",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isPropertyLocation"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v18/*: any*/)
      ],
      "type": "PropertyLocationWithHiddenAddress",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v18/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        }
      ],
      "type": "PropertyLocationWithVisibleAddress",
      "abstractKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ConversationsListRelay_ConversationEventsSubscription",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "conversationEvents",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ConversationV5",
                "kind": "LinkedField",
                "name": "conversation",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ConversationsListItem_conversation"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "NewConversationEvent",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ConversationMessageV5",
                "kind": "LinkedField",
                "name": "message",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ConversationsListItem_lastMessage"
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ConversationV5",
                "kind": "LinkedField",
                "name": "conversation",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "NewConversationReplyEvent",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "ConversationsListRelay_ConversationEventsSubscription",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "conversationEvents",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ConversationV5",
                "kind": "LinkedField",
                "name": "conversation",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ConversationMessageV5",
                    "kind": "LinkedField",
                    "name": "lastMessage",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v11/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "unreadMessages",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "readState",
                        "value": "UNREAD"
                      }
                    ],
                    "concreteType": "ConversationMessagesConnection",
                    "kind": "LinkedField",
                    "name": "messages",
                    "plural": false,
                    "selections": (v6/*: any*/),
                    "storageKey": "messages(readState:\"UNREAD\")"
                  },
                  {
                    "alias": "conversationListParticipants",
                    "args": (v12/*: any*/),
                    "concreteType": "ConversationParticipantConnection",
                    "kind": "LinkedField",
                    "name": "participants",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ConversationParticipantEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v3/*: any*/),
                                  (v13/*: any*/),
                                  {
                                    "alias": "agentProfilePhoto",
                                    "args": null,
                                    "concreteType": "ProfilePhoto",
                                    "kind": "LinkedField",
                                    "name": "profilePhoto",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": [
                                          (v14/*: any*/),
                                          {
                                            "kind": "Literal",
                                            "name": "width",
                                            "value": 60
                                          }
                                        ],
                                        "kind": "ScalarField",
                                        "name": "url",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "membershipStatus",
                                    "storageKey": null
                                  }
                                ],
                                "type": "Agent",
                                "abstractKey": null
                              },
                              (v10/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "participants(first:20)"
                  },
                  {
                    "alias": "participantNames",
                    "args": (v12/*: any*/),
                    "concreteType": "ConversationParticipantConnection",
                    "kind": "LinkedField",
                    "name": "participants",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ConversationParticipantEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v3/*: any*/),
                                  (v13/*: any*/)
                                ],
                                "type": "Agent",
                                "abstractKey": null
                              },
                              (v10/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "participants(first:20)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "conversationContext",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "entityType",
                            "storageKey": null
                          }
                        ],
                        "type": "RemovedConversationContext",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "context",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v16/*: any*/),
                                "type": "BuyerNeedV5",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v17/*: any*/),
                                  (v19/*: any*/)
                                ],
                                "type": "ForSalePropertyV5",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CategoryV5",
                                    "kind": "LinkedField",
                                    "name": "category",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "name",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "subject",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": "messageBroadcastStatus",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "status",
                                    "storageKey": null
                                  }
                                ],
                                "type": "MessageBroadcast",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v16/*: any*/),
                                "type": "RentalNeedV5",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v19/*: any*/),
                                  (v17/*: any*/)
                                ],
                                "type": "RentalPropertyV5",
                                "abstractKey": null
                              },
                              (v10/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "AvailableConversationContext",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "prependNode",
                "key": "",
                "kind": "LinkedHandle",
                "name": "conversation",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  },
                  {
                    "kind": "Literal",
                    "name": "edgeTypeName",
                    "value": "QueryConversationV5Edge"
                  }
                ]
              }
            ],
            "type": "NewConversationEvent",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ConversationMessageV5",
                "kind": "LinkedField",
                "name": "message",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v11/*: any*/),
                  (v9/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ConversationV5",
                "kind": "LinkedField",
                "name": "conversation",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v9/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "NewConversationReplyEvent",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b79891269102fb356ce7952d5b8c9e9f",
    "id": null,
    "metadata": {},
    "name": "ConversationsListRelay_ConversationEventsSubscription",
    "operationKind": "subscription",
    "text": "subscription ConversationsListRelay_ConversationEventsSubscription(\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  conversationEvents {\n    __typename\n    ... on NewConversationEvent {\n      conversation {\n        ...ConversationsListItem_conversation\n        nodeId\n      }\n    }\n    ... on NewConversationReplyEvent {\n      message {\n        ...ConversationsListItem_lastMessage\n        nodeId\n      }\n      conversation {\n        id\n        nodeId\n      }\n    }\n  }\n}\n\nfragment AgentProfilePhoto_agent on Agent {\n  displayName\n  agentProfilePhoto: profilePhoto {\n    url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n  }\n}\n\nfragment ConversationParticipantsDisplay_participantsConnection on ConversationParticipantConnection {\n  edges {\n    node {\n      __typename\n      ... on Agent {\n        id\n        displayName\n        ...AgentProfilePhoto_agent\n        membershipStatus\n      }\n      ... on AnonymousConversationParticipant {\n        __typename\n      }\n      ... on Node {\n        __isNode: __typename\n        __typename\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ConversationsListItemContextLocationDisplay_location on PropertyLocation {\n  __isPropertyLocation: __typename\n  __typename\n  ... on PropertyLocationWithHiddenAddress {\n    locationDisplay\n  }\n  ... on PropertyLocationWithVisibleAddress {\n    locationDisplay\n    address\n  }\n}\n\nfragment ConversationsListItemContext_conversation on ConversationV5 {\n  conversationContext {\n    __typename\n    ... on RemovedConversationContext {\n      entityType\n    }\n    ... on AvailableConversationContext {\n      context {\n        __typename\n        ... on BuyerNeedV5 {\n          headline\n          priceRange {\n            maxPrice {\n              formatted(format: SHORT)\n            }\n            minPrice {\n              formatted(format: SHORT)\n            }\n          }\n        }\n        ... on ForSalePropertyV5 {\n          images {\n            edges {\n              node {\n                url(width: 324, embed: true, crop: true, height: 324, ratio: $__relay_internal__pv__DevicePixelRatio)\n                nodeId\n              }\n            }\n          }\n          propertyLocation {\n            __typename\n            ...ConversationsListItemContextLocationDisplay_location\n          }\n        }\n        ... on MessageBroadcast {\n          category {\n            name\n          }\n          subject\n          messageBroadcastStatus: status\n        }\n        ... on RentalNeedV5 {\n          headline\n          priceRange {\n            maxPrice {\n              formatted(format: SHORT)\n            }\n            minPrice {\n              formatted(format: SHORT)\n            }\n          }\n        }\n        ... on RentalPropertyV5 {\n          propertyLocation {\n            __typename\n            ...ConversationsListItemContextLocationDisplay_location\n          }\n          images {\n            edges {\n              node {\n                url(width: 324, embed: true, crop: true, height: 324, ratio: $__relay_internal__pv__DevicePixelRatio)\n                nodeId\n              }\n            }\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          __typename\n          nodeId\n        }\n      }\n    }\n  }\n}\n\nfragment ConversationsListItemParticipants_conversation on ConversationV5 {\n  conversationListParticipants: participants(first: 20) {\n    ...ConversationParticipantsDisplay_participantsConnection\n  }\n}\n\nfragment ConversationsListItem_conversation on ConversationV5 {\n  id\n  lastMessage {\n    ...ConversationsListItem_lastMessage\n    nodeId\n  }\n  unreadMessages: messages(readState: UNREAD) {\n    totalCount\n  }\n  ...ConversationsListItemParticipants_conversation\n  participantNames: participants(first: 20) {\n    edges {\n      node {\n        __typename\n        ... on Agent {\n          id\n          displayName\n        }\n        ... on AnonymousConversationParticipant {\n          __typename\n        }\n        ... on Node {\n          __isNode: __typename\n          __typename\n          nodeId\n        }\n      }\n    }\n  }\n  ...ConversationsListItemContext_conversation\n}\n\nfragment ConversationsListItem_lastMessage on ConversationMessageV5 {\n  sentAt\n  text\n  files {\n    totalCount\n  }\n  images {\n    totalCount\n  }\n  from {\n    __typename\n    ... on Agent {\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      __typename\n      nodeId\n    }\n  }\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

let node = makeNode(providedVariablesDefinition);

let wrap_response_conversationEvents = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_conversationEvents = unwrap_response_conversationEvents;
exports.wrap_response_conversationEvents = wrap_response_conversationEvents;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
/* node Not a pure module */
